import script from "./UserFeedback.vue?vue&type=script&setup=true&lang=js"
export * from "./UserFeedback.vue?vue&type=script&setup=true&lang=js"

import "@/features/user/styles/operationArea/UserFeedback.css?vue&type=style&index=0&id=cf6a23da&scoped=true&lang=css&external"
import "@/features/user/styles/operationArea/OperationAreaTheme.css?vue&type=style&index=1&id=cf6a23da&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf6a23da"]])

export default __exports__